// extracted by mini-css-extract-plugin
export default {"flexBaseWidth":"CQgwgxYT4hfiPszNzGQ7","avatar":"X1ODMbxxuuqDEu_4TTnF"};